import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BaseDataContextProvider } from './contexts/BaseContext';

ReactDOM.render(
    // <React.StrictMode>
    <BaseDataContextProvider>
        <App />
    </BaseDataContextProvider>,
    // </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
